// server/models/User.ts
import { AssetDTO, BaseEntityDTO, IAssetDTO, IBaseEntityDTO, IRoleDTO, RoleDTO } from './';

export interface IUserDTO extends IBaseEntityDTO {
  first_name: string;
  last_name: string;
  email_address: string;
  password?: string;
  is_under_18: boolean;
  phone_number: string;
  role?: IRoleDTO;
  avatar?: IAssetDTO;
  street_address: string;
  city: string;
  state: string;
  postal_code: string;
  country: string;
  force_reset: boolean;
  validated: boolean;
  birthday?: Date;
  isUnder18: boolean;
  address: string;
  displayName: string;
  notUpToDate: boolean;
}

export class UserDTO extends BaseEntityDTO implements IUserDTO {
  first_name: string;
  last_name: string;
  email_address: string;
  password?: string;
  is_under_18: boolean;
  phone_number: string;
  role?: IRoleDTO;
  avatar?: IAssetDTO;
  street_address: string;
  city: string;
  state: string;
  postal_code: string;
  country: string;
  force_reset: boolean;
  validated: boolean;
  birthday?: Date;

  constructor(data?: Partial<UserDTO>) {
    super();
    if (data) {
      Object.assign(this, data);
    }
    this.first_name = data?.first_name ?? '';
    this.last_name = data?.last_name ?? '';
    this.email_address = data?.email_address ?? '';
    this.password = data?.password ?? '';
    this.is_under_18 = data?.is_under_18 ?? false;
    this.phone_number = data?.phone_number ?? '';
    this.role = data?.role ? new RoleDTO(data.role) : new RoleDTO();
    this.avatar = data?.avatar ? new AssetDTO(data.avatar) : new AssetDTO();
    this.street_address = data?.street_address ?? '';
    this.city = data?.city ?? '';
    this.state = data?.state ?? '';
    this.postal_code = data?.postal_code ?? '';
    this.country = data?.country ?? '';
    this.force_reset = data?.force_reset ?? true;
    this.validated = data?.validated ?? false;
    this.birthday = data?.birthday ?? undefined;
  }

  get isUnder18(): boolean {
    if (!this.birthday) {
      return false;
    }
    const today = new Date();
    const eighteenYearsAgo = new Date();
    eighteenYearsAgo.setFullYear(today.getFullYear() - 18);
    const birthDate = new Date(this.birthday);
    return birthDate >= eighteenYearsAgo;
  }

  get address(): string {
    return `${this.street_address}, ${this.city}, ${this.state} ${this.postal_code}, ${this.country}`;
  }

  get displayName(): string {
    return `${this.first_name} ${this.last_name}`;
  }

  get notUpToDate(): boolean {
    return (
      isNullOrEmpty(this.first_name) ||
      isNullOrEmpty(this.last_name) ||
      isNullOrEmpty(this.email_address) ||
      isNullOrEmpty(this.phone_number) ||
      isNullOrEmpty(this.street_address) ||
      isNullOrEmpty(this.city) ||
      isNullOrEmpty(this.state) ||
      isNullOrEmpty(this.postal_code) ||
      isNullOrEmpty(this.country) ||
      !this.birthday
    );
  }
}

function isNullOrEmpty(value: string | undefined) {
  return !value || value === '' || value == undefined;
}
